<template>
  <transition name="fade">
    <div v-if="!closed" :class="wrapClasses">
      <span v-if="showIcon" :class="prefix+'__icon'">
        <slot v-if="showIcon" name="icon">
          <t-icon :class="prefix+'__icon'" :icon="iconType"></t-icon>
        </slot>
      </span>
      <div :class="contentClasses">
        <span :class="messageClasses"><slot></slot></span>
        <div v-if="desc" :class="descClasses">
          <slot name="desc"></slot>
        </div>
      </div>
      <a v-if="closable" :class="closeClasses" @click="onACloseClick">
        <slot name="close">
          <t-icon icon="close"></t-icon>
        </slot>
      </a>
    </div>
  </transition>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_ALERT_CLASS = `${PREFIX_CLASS}alert`

export default {
  name: 'TAlert',
  props: {
    type: {
      type: String,
      validator(value) {
        return ['success', 'info', 'warning', 'danger', ''].includes(value)
      },
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prefix: PREFIX_ALERT_CLASS,
      closed: false,
      desc: false
    }
  },
  computed: {
    wrapClasses() {
      return [
        `${PREFIX_ALERT_CLASS}`,
        {
          [`${PREFIX_ALERT_CLASS}--${this.type}`]: this.type,
          [`${PREFIX_ALERT_CLASS}--with-icon`]: this.showIcon,
          [`${PREFIX_ALERT_CLASS}--with-desc`]: this.desc
        }
      ]
    },
    contentClasses() {
      return `${PREFIX_ALERT_CLASS}__content`
    },
    messageClasses() {
      return `${PREFIX_ALERT_CLASS}__message`
    },
    descClasses() {
      return `${PREFIX_ALERT_CLASS}__desc`
    },
    closeClasses() {
      return `${PREFIX_ALERT_CLASS}__close-icon`
    },
    iconType() {
      let type = ''

      switch (this.type) {
        case 'success':
          type = `check-circle`
          break
        case 'info':
          type = `information`
          break
        case 'warning':
          type = `information`
          break
        case 'danger':
          type = `close-circle`
          break
      }
      return type
    }
  },
  created() {
    this.desc = this.$slots.desc !== undefined
  },
  methods: {
    onACloseClick(e) {
      this.closed = true
      this.$emit('on-close', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/alert/alert.vue